import { ChakraProvider } from '@chakra-ui/react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { ParallaxProvider } from 'react-scroll-parallax'

import store from '@core/app/store/store'

import '../../index.css'
import { IsApplyDialogProvider } from '@core/utils/contexts/ApplyDialogContext/ApplDialogContext'
import { ModalProvider } from '@core/utils/contexts/ModalContext/ModalContextProvider'
import { ThemeProvider } from '@core/utils/contexts/ThemeContext/ThemeContext'

import { PostsPageNew } from './PostsPageNew'
import theme from '../../theme'
import { PostsPage } from '././PostsPage'

import { MantineProvider } from '@mantine/core'

import '@core/utils/i18n'

import React from 'react'

import { generateRoutes, CustomURL } from '@core/utils/helpers/customeRouteBuilder'

const urls = generateRoutes('', '/jobs')

const routeCollection: object[] = []

urls.forEach((element: CustomURL) => {
    routeCollection.push({
        path: element.url,
        element: (
            <ThemeProvider>
                <IsApplyDialogProvider>
                    <MantineProvider>
                        {/*<PostsPage />*/}
                        <PostsPageNew />
                    </MantineProvider>
                </IsApplyDialogProvider>
            </ThemeProvider>
        ),
    })
})

const router = createBrowserRouter(routeCollection)

const app = document.getElementById('root')
const root = createRoot(app!)
root.render(
    <>
        <Provider store={store}>
            <ChakraProvider theme={theme}>
                <ModalProvider>
                    <ParallaxProvider scrollAxis="vertical">
                        <RouterProvider router={router} />
                    </ParallaxProvider>
                </ModalProvider>
            </ChakraProvider>
        </Provider>
    </>
)
